import script from "./OfferHome.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferHome.vue?vue&type=script&setup=true&lang=js"

import "./OfferHome.vue?vue&type=style&index=0&id=4dc28e7a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc28e7a"]])

export default __exports__